@switch (inviteSignupProcessService.step | async) {
  @case (inviteSignupProcessStepEnum.Identity) {
    <app-invite-signup-process-identity></app-invite-signup-process-identity>
  }
  @case (inviteSignupProcessStepEnum.Details) {
    <app-invite-signup-process-details></app-invite-signup-process-details>
  }
  @case (inviteSignupProcessStepEnum.Phone) {
    <app-invite-signup-process-phone
      [prohibitClosing]="true"></app-invite-signup-process-phone>
  }
  @case (inviteSignupProcessStepEnum.Sms) {
    <app-invite-signup-process-sms></app-invite-signup-process-sms>
  }
  @case (inviteSignupProcessStepEnum.Address) {
    <app-invite-signup-process-address></app-invite-signup-process-address>
  }
  @case (inviteSignupProcessStepEnum.Contract) {
    <app-invite-signup-process-contract></app-invite-signup-process-contract>
  }
  @case (inviteSignupProcessStepEnum.Congratulations) {
    <app-invite-signup-process-congratulations></app-invite-signup-process-congratulations>
  }
}
